import { Component } from "@angular/core";

@Component({
    selector: "app-cp-12-18-10-12",
    standalone: true,
    templateUrl: "./cp-12-18-10-12.component.html",
    styleUrls: ["./cp-12-18-10-12.component.scss"]
})
export class CP12181012Component {

}